<template lang="pug">
	.editor-control-input-coords-drag(:style="{zIndex: dragProcess ? 2000 : 2}" :class="{'change-process': changedValue !== null, [theme]: true}")
		.cursor-container(v-if="dragProcess" :style="{cursor: ({x: 'ew-resize', y: 'ns-resize', 'xy': 'move'})[dragProcess.propertyModifier]}")
		.input-title(v-if="title") {{title}}
		.control-coords
			.control-point-input
				label(v-on:wheel="processChangeValueByMouseWheel('x', $event)")
					.label(:class="{active: (dragProcess && dragProcess.propertyModifier === 'x') || isDisplayedValueChanged('x')}" v-on:mousedown="startDrag('x', $event)") {{options.messages?.labels?.[0] || 'X'}}
					input.form-control.form-control-sm(:value="getDisplayedValue('x')" :style="{width: options.controlOptions.inputWidth ? `${options.controlOptions.inputWidth}px` : undefined}" v-on:keydown="startChangeValueByKeyPress('x', $event)" v-on:input="changeValueByInput('x', $event.target.value, $event, false)" v-on:change="changeValueByInput('x', $event.target.value, $event)" v-on:focus="blockUpdate()" v-on:blur="unblockUpdate()")
			.control-point-input
				label(v-on:wheel="processChangeValueByMouseWheel('y', $event)")
					.label(:class="{active: (dragProcess && dragProcess.propertyModifier === 'y') || isDisplayedValueChanged('y')}" v-on:mousedown="startDrag('y', $event)") {{options.messages?.labels?.[1] || 'Y'}}
					input.form-control.form-control-sm(:value="getDisplayedValue('y')" :style="{width: options.controlOptions.inputWidth ? `${options.controlOptions.inputWidth}px` : undefined}" v-on:keydown="startChangeValueByKeyPress('y', $event)" v-on:input="changeValueByInput('y', $event.target.value, $event, false)" v-on:change="changeValueByInput('y', $event.target.value, $event)" v-on:focus="blockUpdate()" v-on:blur="unblockUpdate()")
			.control-point-drag(v-if="options.controlOptions.drag" :class="{active: dragProcess && dragProcess.propertyModifier === 'xy'}" v-on:mousedown="startDrag('xy', $event)")
				.fa.fa-arrows
</template>

<script>

	import Screen 							from './../../../mixins/screen'

	import { Elements }						from './../../../services/Elements'

	export default {
		name: 'InputCoordsDrag',
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Version Switched",
				"Selected Screen Switched",
				"Selected Element Switched"
			],
			events: {
				"Selected Element Changed": function() {

					this.update();

				}
			}
		},
		components: {},
		props: ["title", "default", "value", "options", "theme"],
		data() {

			this.element = null;

			this.dragProcess = null;
			this.keyPressProcess = null;

			return {
				showed: true,
				changedValue: null
			};

		},
		mounted() {

			window.addEventListener("mouseup", () => {

				if (this.dragProcess) this.stopDrag();

			});

			window.addEventListener("mousemove", e => {

				if (this.dragProcess) this.processDrag(e);

			});

			window.addEventListener("keydown", e => {

				if (e.keyCode === 16) {

					if (this.keyPressProcess) this.keyPressProcess.shiftKey = true;
					if (this.dragProcess) this.dragProcess.shiftKey = true;

					this.update();

				}

				if (e.keyCode === 17) {

					if (this.keyPressProcess) this.keyPressProcess.ctrlKey = true;
					if (this.dragProcess) this.dragProcess.ctrlKey = true;

					this.update();

				}

			});

			window.addEventListener("keyup", e => {

				if (this.keyPressProcess && (e.keyCode === 38 || e.keyCode === 40)) this.stopChangeValueByKeyPress();

				if (e.keyCode === 16) {

					if (this.keyPressProcess) this.keyPressProcess.shiftKey = false;
					if (this.dragProcess) this.dragProcess.shiftKey = false;

					this.update();

				}

				if (e.keyCode === 17) {

					if (this.keyPressProcess) this.keyPressProcess.ctrlKey = false;
					if (this.dragProcess) this.dragProcess.ctrlKey = false;

					this.update();

				}

			});

		},
		methods: {
			collectData() {

				this.element = Elements.SelectedElement;

			},
			getValue() {

				let value = null;

				if (this.changedValue !== null) value = this.changedValue;
				else if (this.value !== undefined && this.value !== null) value = _.cloneDeep(this.value);
				else value = this.default;

				value = this.restoreValueType(value);

				return value;

			},
			getDisplayedValue(propertyModifier = null) {

				let value = this.getValue();

				if (propertyModifier === 'x') value = value[0];
				else if (propertyModifier === 'y') value = value[1];

				if (this.options.controlOptions?.percents) value = `${parseInt(value * 100)}%`;
				else if (this.options.changes && "accuracy" in this.options.changes) value = parseInt(value * Math.pow(10, this.options.changes.accuracy)) / Math.pow(10, this.options.changes.accuracy);

				return value;

			},
			setValue(value, fixAccuracy = true, forceUpdate = false) {

				if (this.options.changes && "max" in this.options.changes) {
					if (value[0] > this.options.changes.max) value[0] = this.options.changes.max;
					if (value[1] > this.options.changes.max) value[1] = this.options.changes.max;
				}

				if (this.options.changes && "min" in this.options.changes) {
					if (value[0] < this.options.changes.min) value[0] = this.options.changes.min;
					if (value[1] < this.options.changes.min) value[1] = this.options.changes.min;
				}

				if (fixAccuracy && this.options.changes && "accuracy" in this.options.changes) this.changedValue = [value[0].toFixed(this.options.changes.accuracy), value[1].toFixed(this.options.changes.accuracy)];
				else this.changedValue = value;

				if (forceUpdate) this.update();

				this.sendValue(this.getValue());

			},
			restoreValueType(value) {

				return [parseFloat(value?.[0]), parseFloat(value?.[1])];

			},
			isDisplayedValueChanged(propertyModifier) {

				if (this.changedValue === null) return false;

				let changedValue = this.restoreValueType(this.changedValue)?.[propertyModifier === 'x' ? 0 : 1],
					baseValue = this.restoreValueType(this.value)?.[propertyModifier === 'x' ? 0 : 1];

				return JSON.stringify(changedValue) !== JSON.stringify(baseValue);

			},
			getChangeProcess() {

				return this.dragProcess;

			},
			changeValueByInput(propertyModifier, value, e = null, isSave = true) {

				if (!e || (e.keyCode !== 38 && e.keyCode !== 40)) {

					if (this.changedValue === null) this.changedValue = this.restoreValueType((this.value !== undefined && this.value !== null) ? _.cloneDeep(this.value) : _.cloneDeep(this.default));

					let newValue = [parseFloat(this.changedValue[0]), parseFloat(this.changedValue[1])];

					value = parseFloat(value);

					if (this.options.controlOptions?.percents) value = value / 100;

					newValue[propertyModifier === 'x' ? 0 : 1] = value;

					if (_.isNaN(value)) value = undefined;

					if (value !== undefined) {

						this.changedValue[propertyModifier === 'x' ? 0 : 1] = value;

						if (isSave) this.setValue(this.changedValue, false);

					}

				}

			},
			startChangeValueByKeyPress(propertyModifier, e) {

				if (e.keyCode === 38 || e.keyCode === 40) {

					if (!this.keyPressProcess) {

						this.keyPressProcess = {
							increaser: e.keyCode === 40 ? -1 : 1,
							shiftKey: e.shiftKey
						};

						this.keyPressProcess.timeout = setTimeout(() => {

							this.changeValue(propertyModifier, this.keyPressProcess.increaser, this.keyPressProcess.shiftKey, true);

							this.keyPressProcess.interval = setInterval(() => {

								this.changeValue(propertyModifier, this.keyPressProcess.increaser, this.keyPressProcess.shiftKey, true);

							}, 50);

						}, 200);

						this.changeValue(propertyModifier, this.keyPressProcess.increaser, this.keyPressProcess.shiftKey, true);

					}

					e.preventDefault();

				}

			},
			stopChangeValueByKeyPress() {

				if (this.keyPressProcess) {

					clearTimeout(this.keyPressProcess.timeout);
					clearInterval(this.keyPressProcess.interval);
					clearTimeout(this.keyPressProcess.stopTimeout);

					this.keyPressProcess = null;

				}

			},
			processChangeValueByMouseWheel(propertyModifier, e) {

				this.changeValue(propertyModifier, Math.sign(e.wheelDelta), e.shiftKey, true);

			},
			startDrag(propertyModifier, e) {

				this.dragProcess = {
					active: false,
					messages: this.options.messages,
					propertyModifier,
					downValue: this.getValue(),
					downPointerPosition: {
						x: e.clientX,
						y: e.clientY
					}
				};

				this.update();

				this.$emit('startDragProcess', this.dragProcess);

			},
			processDrag(e) {

				if (this.dragProcess.active) {

					let offsetX = (e.clientX - this.dragProcess.downPointerPosition.x),
						offsetY = (e.clientY - this.dragProcess.downPointerPosition.y);

					if (this.options.controlOptions["revertY"]) offsetY *= -1;

					if (this.dragProcess.propertyModifier === 'x') offsetY = 0;
					if (this.dragProcess.propertyModifier === 'y') offsetX = 0;

					// Делаем так чтобы смещение на 10 пикселей смещало значение на один шаг
					if (this.options.changes?.step) {

						let pixelWeight = this.options.changes?.step / 10;

						offsetX = offsetX * pixelWeight;
						offsetY = offsetY * pixelWeight;

					}

					let newValue = [this.dragProcess.downValue[0], this.dragProcess.downValue[1]];

					if (this.options.controlOptions["sameValueByDefault"] && this.dragProcess.propertyModifier === 'xy' && !e.shiftKey) {

						let offset = offsetY;

						let averageScale = (Math.abs(this.dragProcess.downValue[0]) + Math.abs(this.dragProcess.downValue[1])) / 2;
						let percent = offset / averageScale;

						newValue = [this.normalizeValue(averageScale + averageScale * percent, 'x'), this.normalizeValue(averageScale + averageScale * percent, 'y')];

					} else {

						if (this.dragProcess.propertyModifier === 'x' || this.dragProcess.propertyModifier === 'xy') newValue[0] = this.normalizeValue(this.dragProcess.downValue[0] + offsetX, 'x');
						if (this.dragProcess.propertyModifier === 'y' || this.dragProcess.propertyModifier === 'xy') newValue[1] = this.normalizeValue(this.dragProcess.downValue[1] + offsetY, 'y');

					}

					this.setValue(newValue);

					this.update();

				} else {

					let dx = e.clientX - this.dragProcess.downPointerPosition.x,
						dy = e.clientY - this.dragProcess.downPointerPosition.y;

					this.dragProcess.active = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2)) > 3;

				}

			},
			stopDrag() {

				this.dragProcess = null;

				this.update();

				this.$emit('stopDragProcess');

			},
			changeValue(propertyModifier, increaser, shiftKey, forceUpdate = false) {

				if (this.changedValue === null) this.changedValue = (this.value !== undefined && this.value !== null) ? _.cloneDeep(this.value) : _.cloneDeep(this.default);

				let newValue = [parseFloat(this.changedValue[0]), parseFloat(this.changedValue[1])];

				newValue[propertyModifier === 'x' ? 0 : 1] += (this.options.changes?.step || 1) * increaser * (shiftKey ? 10 : 1);

				this.setValue(newValue, false, forceUpdate);

			},
			normalizeValue(value, propertyModifier) {

				if (this.dragProcess?.shiftKey && this.options.shiftSnap) value = this.normalizeSnap(value, this.options.shiftSnap, propertyModifier);

				if (this.dragProcess?.ctrlKey && this.options.ctrlSnap) value = this.normalizeSnap(value, this.options.ctrlSnap, propertyModifier);

				return value;

			},
			normalizeSnap(value, options, propertyModifier) {

				if (options.type === "values") {

					_.each(options.values, snapValue => {

						if (Math.abs(value - snapValue) <= options.count) value = snapValue;

					});

				} else if (options.type === "start-value") {

					let snapValue = propertyModifier === 'x' ? this.dragProcess.downValue[0] : this.dragProcess.downValue[1];

					if (Math.abs(value - snapValue) <= options.count) value = snapValue;

				}

				return value;

			},
			blockUpdate() {

				// Запрещаем апдейт компонента пока фокус стоит в поле ввода информации
				this.updateBlocked = true;
				this.sendBlocked = true;

			},
			unblockUpdate() {

				this.updateBlocked = false;
				this.sendBlocked = false;

				// Пробуем через таймаут обновить компонент
				// Если updateBlocked к этому моменту всё ещё будет false то компонент обновится и отобразит новые клиентские данные
				// Это делается чтобы заблокировать обновление полей ввода пока пользователь не завершил их ввод
				// Без этого автообновления мешают печатать новые значения в полях типа coords
				clearTimeout(this.updateTimeout);
				this.updateTimeout = setTimeout(() => {

					this.update();

					if (this.changedValue !== null && !_.isEqual(this.changedValue, this.value)) this.sendValue(this.getValue());

				}, 200);

			},
			sendValue(value) {

				this.$emit('input', value);

				if (this.sendBlocked) return;

				clearTimeout(this.sendTimeout);
				this.sendTimeout = setTimeout(() => {

					this.$emit('change', value);

					//this.changedValue = null;

					this.update();

				}, 500);

			}
		}

	}
</script>

<style lang="sass">

	.editor-control-input-coords-drag
		color: #f3f4f5
		display: flex
		flex-direction: row
		flex-wrap: nowrap
		min-height: 31px
		align-items: center

		.cursor-container
			position: fixed
			z-index: 2
			left: 0
			top: 0
			width: 100%
			height: 100%
			cursor: move

		.input-title
			display: flex
			justify-content: right
			//width: 100px
			overflow: hidden
			text-overflow: ellipsis
			color: var(--secondary)
			font-size: 0.85rem
			padding-right: 0.5rem
			cursor: default
			user-select: none

		.control-coords
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			align-items: center
			justify-content: left

			.control-point-input
				display: flex
				flex-direction: row
				flex-wrap: nowrap

				color: rgba(255, 255, 255, 0.87)
				background-color: #515b65
				border: 1px solid #23282c
				transition: border-color 0.35s ease-in-out, box-shadow 0.35s ease-in-out, color 0.35s ease-in-out
				overflow: hidden
				height: 35px
				border-radius: 0.25rem
				border-top-left-radius: 0
				border-bottom-left-radius: 0
				margin-left: -1px

				&:first-child
					border-top-right-radius: 0
					border-bottom-right-radius: 0
					border-top-left-radius: 0.25rem
					border-bottom-left-radius: 0.25rem
					margin-left: 0

				label
					display: flex
					flex-direction: row
					flex-wrap: nowrap
					margin: 0
					padding: 0

					.label
						display: flex
						justify-content: center
						align-items: center
						margin-top: -1px
						color: #73818f
						cursor: pointer
						user-select: none
						background-color: rgba(0, 0, 0, 0.05)
						border-right: 1px solid rgba(0, 0, 0, 0.15)
						padding: 0 7px

					input
						margin: 0
						width: 50px
						height: 100%
						box-shadow: none
						outline: none !important
						border-radius: 0
						border: none
						background-color: transparent
						padding: 0 7px
						color: #e4e7ea
						font-size: 14px

			.control-point-drag
				display: flex
				justify-content: center
				align-items: center
				width: 30px
				height: 30px
				border: 1px solid rgba(255, 255, 255, 0.09)
				background-color: rgba(255, 255, 255, 0.05)
				border-radius: 0.1rem
				cursor: pointer
				margin-left: 5px
				color: #73818f
				user-select: none

				&:hover
					border: 1px solid rgba(255, 255, 255, 0.4)
					color: rgba(255, 255, 255, 0.4)

	.editor-control-input-coords-drag.dark-mini

		.control-coords

			.control-point-input
				min-width: 60px
				height: 24px
				background-color: rgba(255, 255, 255, 0.05)
				border: 1px solid rgba(255, 255, 255, 0.09)
				border-radius: 0.1rem

				&:first-child
					border-top-right-radius: 0
					border-bottom-right-radius: 0
					border-top-left-radius: 0.1rem
					border-bottom-left-radius: 0.1rem
					margin-left: 0

				label

					.label
						min-width: 20px
						padding: 0 5px
						border-right: 1px solid rgba(255, 255, 255, 0.05)

					input
						padding: 0 3px
						width: 35px
						font-size: 0.765625rem

			.control-point-drag
				width: 20px
				height: 20px

	.editor-control-input-coords-drag.dark-medium

		.control-coords

			.control-point-input
				min-width: 60px
				height: 30px
				background-color: #515b65
				border: 1px solid #23282c
				border-top-right-radius: 0.25rem
				border-bottom-right-radius: 0.25rem
				border-top-left-radius: 0
				border-bottom-left-radius: 0
				transition: none

				&:first-child
					border-top-right-radius: 0
					border-bottom-right-radius: 0
					border-top-left-radius: 0.25rem
					border-bottom-left-radius: 0.25rem
					margin-left: 0

				label
					text-transform: uppercase

					.label
						min-width: 20px
						padding: 0 5px
						border-right: 1px solid rgba(255, 255, 255, 0.05)

					input
						padding: 0 3px
						width: 35px
						font-size: 0.765625rem

			.control-point-input:hover
				background: #515b65
				border: 1px solid rgba(255, 255, 255, 0.3)
				z-index: 10

			.control-point-drag
				width: 24px
				height: 24px

	.editor-control-input-coords-drag.change-process

		.control-coords

			.control-point-input

				label

					.label.active
						color: #20a8d8

			.control-point-drag.active
				color: #20a8d8
				border-color: #20a8d8



</style>
